module.exports = __webpack_public_path__ + "media/images/logo-bancontact-9d00d0d25b9e67d98a6273ae9989e162.png";